import Axios from "axios";

let baseUrl = process.env.VUE_APP_APIURL;

if (!baseUrl.includes("dev"))
  baseUrl = "https://api-cdn.blueticket.com.br/api/";

const CdnApi = Axios.create({
  baseURL: baseUrl,
});

export default CdnApi;
